import { IconMountainOutline24 } from "nucleo-core-outline-24";
import type { IconProps } from "nucleo-ui-outline-18";
import {
  IconArrowRightOutline18,
  IconBoltOutline18,
  IconBookOpenOutline18,
  IconBookOutline18,
  IconCodeOutline18,
  IconCompassOutline18,
  IconFlagOutline18,
  IconGearOutline18,
  IconKeyOutline18,
  IconLayersOutline18,
  IconMapOutline18,
  IconMediaPlayOutline18,
  IconNavigationOutline18,
  IconPinOutline18,
  IconPlugOutline18,
  IconRadioOutline18,
  IconRocketOutline18,
  IconRouteOutline18,
  IconSliders2Outline18,
  IconSparkleOutline18,
  IconTerminalOutline18,
} from "nucleo-ui-outline-18";
import type { FC } from "react";

/**
 * Icon is the component type every Nucleo glyph satisfies, whatever family or size
 * it comes from. Declared here rather than imported so this package stays a leaf —
 * reaching into @mountayaapp/theme for the same alias would drag its CSS modules and
 * SVG assets into a tsconfig that has no ambient declarations for them.
 */
export type Icon = FC<IconProps>;

/**
 * docIcons maps the icon names {% button %} and {% card %} accept to their
 * Nucleo components. An unknown name resolves to undefined so the renderer
 * simply omits the icon rather than failing.
 */
export const docIcons: Record<string, Icon> = {
  "arrow-right": IconArrowRightOutline18,
  book: IconBookOutline18,
  "book-open": IconBookOpenOutline18,
  code: IconCodeOutline18,
  compass: IconCompassOutline18,
  flag: IconFlagOutline18,
  key: IconKeyOutline18,
  layers: IconLayersOutline18,
  map: IconMapOutline18,
  "map-pin": IconPinOutline18,
  mountain: IconMountainOutline24,
  navigation: IconNavigationOutline18,
  play: IconMediaPlayOutline18,
  plug: IconPlugOutline18,
  radio: IconRadioOutline18,
  rocket: IconRocketOutline18,
  route: IconRouteOutline18,
  settings: IconGearOutline18,
  sliders: IconSliders2Outline18,
  sparkles: IconSparkleOutline18,
  terminal: IconTerminalOutline18,
  zap: IconBoltOutline18,
};

/**
 * resolveIcon looks a {% button %}/{% card %} `icon` name up in the Nucleo set,
 * returning undefined for an absent or unrecognized name.
 */
export const resolveIcon = (name?: string): Icon | undefined => (name ? docIcons[name] : undefined);
